<template>
  <div class="hairdressing-manager-wrapper" v-if="refreshControl">
    <div class="main-left">
      <div class="top-content">
        <CommonPatientForm />
      </div>
      <div class="bottom-content">
        <CommonDiagnosisForm />
      </div>
    </div>
    <div class="main-center">
      <div class="top-content">
        <CommonUploadImages
          ref="CommonUploadImages"
          @takeAPhone="takeAPhone('hairdressing')"
          @lookBigPhoto="lookBigPhoto"
        ></CommonUploadImages>
      </div>
      <div class="bottom-content">
        <CommonHairdressingInfo />
      </div>
    </div>
    <div class="main-right">

      <div class="top-content">
        <CommonHistoryList />
      </div> 
      <div class="bottom-content">
        <CommonHairdressingDigest />
      </div>


      <!-- <CommonHistoryList /> -->
    </div>
    <div class="mask" v-if="isTakePhone" @keydown="keydownTakePicture" tabindex="-1"></div>
    <div
      v-show="isTakePhone"
      class="camera-con"
      tabindex="-1"
      @keydown="keydownTakePicture"
      ref="cameraCon"
    >
      <div class="booth">
        <div class="titleCon">
          <div class="leftCon">
            <img src="../assets/camera.png" style="width:30px;height:auto;" />
            <div style="margin-left:10px;">影像采集</div>
          </div>
          <el-select
            class
            v-model="selectCamera"
            placeholder="没有找到设备"
            no-data-text="没有可选设备"
            @change="cameraChange"
          >
            <el-option
              v-for="item in CameraList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
           <el-select
            class=""
            v-model="selectPhotoSize"
            @change="changePhotoSize"
          >
            <el-option
              v-for="item in photoSizeList"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
          <!--&lt;!&ndash;<div class="rightCon" v-if="skin">&ndash;&gt;
          &lt;!&ndash;<button class="btn" @click="jr">浸润（空格键）</button>&ndash;&gt;
          &lt;!&ndash;<button class="btn" @click="pz" style="margin-right:10px;">偏振光</button>&ndash;&gt;
          &lt;!&ndash;</div>&ndash;&gt;
          <el-select v-model="selectSkinType" placeholder="请选择" v-if="skin">
            <el-option
              v-for="item in SkinType"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>-->
          <div class="rightCon">
            <div
              class="btn"
              @click="takePicture"
              style="margin-right:10px;width: 150px;height: 30px;box-sizing: border-box;font-size:14px;user-select: none;"
            >拍摄（空格键）</div>
          </div>
          <img
            src="../assets/close.png"
            style="width:30px;height:auto;cursor:pointer;margin-right: 16px;"
            @click="closeCamera"
          />
        </div>
        <div
          style="position: relative;"
          v-loading="takePhotoLoading"
          element-loading-text="正在上传"
          element-loading-spinner="el-icon-loading"
          element-loading-background="rgba(255, 255, 255, 0.2)"
        >
          <video
            id="video"
            ref="video"
            muted
            style="width:98%;margin-left:1%;margin-bottom: 10px;"
            @click="takePicture"
            @canplay="videoCanPlay"
          ></video>
          <div class="video-flash" v-show="isShowVideoFlash"></div>
        </div>
        <canvas
          id="canvas"
          :width="videoWidth"
          :height="videoHeight"
          ref="imgCanvas"
          style="opacity:0;z-index: -1"
        ></canvas>
      </div>
    </div>

    <el-dialog
      :visible.sync="showLargeImage"
      center
      custom-class="similarDialog showBigImage_dialog"
      modal
      top="0"
      :fullscreen="true"
      :before-close="closeShowLargeImage"
      v-if="showLargeImage"
    >
      <div
        style="position: absolute;left: 20px;right: 20px;top: 45px;bottom:20px;display: flex;align-items: center"
      >
        <CompareImage
          :primevalImage="primevalImage"
          :compareImageList="compareImageList"
          :isCompareImage="isCompareImage"
          :largeImgage="largeImgage"
          :largeImgage2="largeImgage2"
          :imageCompileClass="imageCompileClass"
          :imageCompileClass2="imageCompileClass2"
          :selected="selected"
          :selected2="selected2"
          :activeImage="activeImage"
          :activeImage2="activeImage2"
          @imageClick="imageClick"
          @imageDblclick="imageDblclick"
          @imageOnload="imageOnload"
          @checkImageCompile="checkImageCompile"
        ></CompareImage>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import CommonPatientForm from "./CommonPatientForm";
import CommonDiagnosisForm from "./CommonDiagnosisForm";
import CommonUploadImages from "./CommonUploadImages";
import CommonHairdressingInfo from "./CommonHairdressingInfo";
import CommonHairdressingDigest from "./CommonHairdressingDigest";
import CommonHistoryList from "./CommonHistoryList";
import takePhotoMethod from "../utils/takePhoto.js";
import CompareImage from "./CompareImage";
import { lookPhoto } from "../utils/lookPhoto.js";
import gql from "graphql-tag";
import photoSize from '../utils/photosSize.js'
import popMixins from "../utils/popMixins.js";
export default {
  components: {
    CommonPatientForm,
    CommonDiagnosisForm,
    CommonUploadImages,
    CommonHairdressingInfo,
    CommonHistoryList,
    CommonHairdressingDigest,
    CompareImage,
  },

  mixins: [takePhotoMethod, lookPhoto,photoSize,popMixins],

  provide() {
    return {
      commonData: this.commonData,
      refreshPage: this.refreshPage,
      selectedImage: this.selectedImage,
      unSelectedImage: this.unSelectedImage,
      getImageInfo: this.getImageInfo,
      getHairdressingTree: this.getHairdressingTree
    };
  },

  data() {
    return {
      commonData: {
        patientId: -1,
        patientIdInHospital: "",
        relevantInfoId: -1,
        treat_no: "",
        balance: "", // 账户余额
        // 美容tree数据
        cosmetologyTree: [],
        // 选择的图片
        selectedImageData: null,
        // 选择了图片后图片的数据
        imageInfo: [],
        // 是否点击了添加标记按钮，如果点击了就显示大图
        isClickAddSign: false,
        // 图片上传的状态
        imageStatus: "无",
        totalNum: 1,
        thisNum: 1,
        parent_id: "",
        isDrawid: -1,
        showLargeImage: false,
      },
      // 清空页面的控制属性
      refreshControl: true,
      // 是否显示大图弹框
      showLargeImage: false
    };
  },
  watch: {
    showLargeImage(val) {
      this.commonData.showLargeImage = val;
    }
  },
  methods: {
    // 清空页面
    refreshPage() {
      this.refreshControl = false;

      this.commonData.patientId = -1;
      this.commonData.patientIdInHospital = "";
      this.commonData.relevantInfoId = -1;
      this.commonData.treat_no = "";
      this.commonData.balance = "";
      this.commonData.cosmetologyTree = [];
      this.commonData.selectedImageData = null;
      this.commonData.imageInfo = [];
      this.commonData.isClickAddSign = false;
      this.commonData.totalNum = 1;
      this.commonData.thisNum = 1;
      this.commonData.parent_id = "";

      this.$nextTick(() => {
        this.refreshControl = true;
        this.getHairdressingTree();
      });
    },
    // 查看大图
    lookBigPhoto(data) {
      this.LookBigPhoto(data.imgPath, data.imgItem, data.id, data.type);
      this.commonData.isDrawid = data.imgItem.id;
    },
    // 请求美容树模板
    async getHairdressingTree() {
      try {
        const res = await this.$apollo.query({
          query: gql`
            {
              getCosmetologyItemTree {
                id
                team_id
                item_name
                device {
                  id
                  item_id
                  device_name
                  treat_module {
                    id
                    item_id
                    device_id
                    module_name
                    params
                  }
                }
              }
            }
          `,
          fetchPolicy: "no-cache"
        });
        this.commonData.cosmetologyTree = res.data.getCosmetologyItemTree;
    
      } catch (error) {
        this.$message.error(error.message.split(":")[1]);
      }
    
      await this.$root.$emit('add-par-num', '1');
    },
    // 点击选择图片
    async selectedImage(imageItem) {
      this.commonData.selectedImageData = imageItem;
      if (this.commonData.isClickAddSign) {
        this.commonData.isClickAddSign = false;
        this.lookBigPhoto({
          imgPath: imageItem.path,
          imgItem: imageItem,
          id: imageItem.id,
          type: "hairdressing"
        });
      }
    },
    // 取消选择图片
    unSelectedImage() {
      this.commonData.selectedImageData = null;
      this.commonData.imageInfo = [];
    },
    // 获取图片信息
    async getImageInfo(imageId) {
      try {
        const res = await this.$apollo.query({
          query: gql`
            query($patient_id: Int!, $treat_no: String!, $image_id: Int!) {
              getCosmetologyTreatDetails(
                patient_id: $patient_id
                treat_no: $treat_no
                image_id: $image_id
              ) {
                id
                item_id
                sign_no
                device_id
                device_info {
                  id
                  device_name
                }
                module_id
                module_info {
                  id
                  module_name
                }
                param_value
              }
            }
          `,
          fetchPolicy: "no-cache",
          variables: {
            patient_id: this.commonData.patientId,
            treat_no: this.commonData.treat_no,
            image_id: imageId
          }
        });
        return res.data.getCosmetologyTreatDetails;
      } catch (error) {
        this.$message.error(error.message.split(":")[1]);
      }
    }
  },

  async mounted() {
    this.video = this.$refs.video;
    this.canvas = this.$refs.imgCanvas;

    // console.log("In HairdressingManager:");
    // console.log("this.$store.state.continueTreatData.statusCount:",this.$store.state.continueTreatData.statusCount);
    // console.log("this.$store.state.modifyCosmetologyData.statusCount:",this.$store.state.modifyCosmetologyData.statusCount);
    // console.log("this.$store.state.cosmetologyData.statusCount:",this.$store.state.cosmetologyData.statusCount);

    // 如果是继续治疗就填上患者信息 清除继续治疗的状态
    if (this.$store.state.continueTreatData.status) {
      const timer = setInterval(() => {
        if (this.$store.state.continueTreatData.statusCount >= 3) {
          clearInterval(timer);
          this.$store.commit('clearContinueTreat');
        }
      }, 600);
    }
    // 如果是点击编辑跳转过来 清除状态
    if (this.$store.state.modifyCosmetologyData.status) {
      // 监视状态值，满足条件就取消继续治疗的状态
      const timer = setInterval(() => {
        if (this.$store.state.modifyCosmetologyData.statusCount >= 5) {
          // console.log("clearModifyCosmetology")
          clearInterval(timer);
          this.$store.commit('clearModifyCosmetology');
        }
      }, 600);
  
    }
    // 如果是点击患者列表跳转过来 清除状态
    if (this.$store.state.cosmetologyData.status) {
      // 监视状态值，满足条件就取消继续治疗的状态
      const timer = setInterval(() => {
        if (this.$store.state.cosmetologyData.statusCount >= 3) {
          // console.log("clearCosmetology")
          clearInterval(timer);
          this.$store.commit('clearCosmetology');
        }
      }, 600);
    
    }
  },

  async created() {
    await this.getHairdressingTree();
  }
};
</script>

<style lang="less" scoped>
.hairdressing-manager-wrapper {
  display: flex;
  width: 100%;
  height: 100%;
  overflow-y: auto;

  .main-left {
    display: flex;
    flex-direction: column;
    width: 330px;
    padding: 5px 0 5px 6px;
    background-color: #eff2f7;
    overflow-y: auto;

    .top-content {
      height: 410px;
      min-height: 410px;
      overflow-y: auto;
    }

    .bottom-content {
      flex: 1;
      min-height: 190px;
      overflow-y: auto;
    }
  }

  .main-center {
    display: flex;
    flex-direction: column;
    flex: 1;
    overflow-y: auto;
    .top-content {
      height: 410px;
      min-height: 410px;
      padding: 0 10px;
      margin-bottom: 5px;
      overflow-y: auto;
    }
    .bottom-content {
      flex: 1;
      padding: 0 10px;
      overflow-y: auto;
    }
  }

  // .main-right {
  //   width: 330px;
  //   background-color: #eff2f7;
  // }
  .main-right {
    display: flex;
    flex-direction: column;
    width: 330px;
    // padding: 5px 0 5px 6px;
    background-color: #eff2f7;
    overflow-y: auto;

    .top-content {
      height: 410px;
      min-height: 410px;
      overflow-y: auto;
    }

    .bottom-content {
      flex: 1;
      min-height: 190px;
      overflow-y: auto;
    }
  }

}

.mask {
  position: absolute;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 5;
}
.camera-con {
  width: 52%;
  position: fixed;
  left: 47%;
  border-radius: 15px;
  background: #ebebeb;
  outline: none;
  z-index: 2005;

  .booth {
    position: relative;

    .titleCon {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      flex-wrap: nowrap;
      margin-bottom: 0.6rem;
      margin-top: 1rem;

      .leftCon {
        display: flex;
        align-items: center;
        min-width: 118px;
        margin-left: 3%;
        color: #7cafc7;
        font-size: 1.2rem;
      }

      .rightCon {
        /*margin-right: -40%;*/
      }
    }

    #canvas {
      position: absolute;
      left: 3rem;
      top: 4rem;
    }
  }
  
  .video-flash{
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background-color: #ffffff;
  }
}
</style>
